import { Duration } from 'dayjs/plugin/duration';

import { ExcavationAndBuildInfoTable } from 'business/shift-report/report/pages/ReportView/components/metadata-container/excavation-and-build';
import { ReportMetadataTable } from 'business/shift-report/report/pages/ReportView/components/metadata-container/report-metadata';
import {
  GetIndicatorResultsQuery,
  GetPreviousPrintReportQuery,
  GetShiftReportPdfMetadataQuery,
} from 'generated/graphql';

import { TotalAvailabilityTable } from './total-availability';

type ReportViewMetadataProps = {
  report: NonNullable<GetShiftReportPdfMetadataQuery['shiftReport']>;

  previousReport: GetPreviousPrintReportQuery['shiftReport'][0] | undefined;
  averageExcavationPerRing: string | null;
  averageBuildPerRing: string | null;

  indicators: NonNullable<
    GetIndicatorResultsQuery['calculateIndicatorResults']
  >['data'];

  totalTasksTime: Duration;
  totalCriticalTasksTime: Duration;
};

export const ReportViewMetadataContainer = ({
  report,
  previousReport,
  averageExcavationPerRing,
  averageBuildPerRing,
  indicators,
  totalTasksTime,
  totalCriticalTasksTime,
}: ReportViewMetadataProps) => {
  return (
    <>
      <ReportMetadataTable report={report} />

      <ExcavationAndBuildInfoTable
        previousReport={previousReport}
        averageExcavationPerRing={averageExcavationPerRing}
        averageBuildPerRing={averageBuildPerRing}
      />

      <TotalAvailabilityTable
        totalTasksTime={totalTasksTime}
        totalCriticalTasksTime={totalCriticalTasksTime}
        indicators={indicators}
      />
    </>
  );
};
